import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row, Form, Label, Input, FormGroup, Button } from "reactstrap"
import { DragDropContext, Droppable, Draggable, resetServerContext } from 'react-beautiful-dnd';
resetServerContext()
import Breadcrumbs from "../../../components/Common/Breadcrumb";
//import { addcaseformAttributesets } from "../../../store/actions"; 
import { addcaseformAttributetemplate, getCaseFormsList, getCaseFormAttributeGroups } from "../../../store/actions";
import {
  reorder,
  move,
  getItemStyle,
  getListStyle,
  getFirstListStyle
} from "../QnnrAttributeSets/helper";
import { useSelector, useDispatch } from "react-redux";
import { getCaseFormAttributeTemplateDetail, updateCaseformAttributetemplates } from "../../../store/admin/caseformattributestemplates/actions";
import { useAlert } from "../../../components/Common/Alert";

import Select, { components } from "react-select"

const FormLayoutsBasic = () => {
  //SAVE DATA
  let form_id = '';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { CaseFormsList } = useSelector((state) => ({
    CaseFormsList: state.CaseFormsList.CaseFormsList,
  }));

  const { CaseFormsSelectList } = useSelector((state) => ({
    CaseFormsSelectList: state.CaseFormsList.CaseFormsSelectList,
  }));


  const queryParams = new URLSearchParams(location.search);
  const editId = queryParams.get('id'); // Read the 'id' query parameter from the URL

  const { caseformattributegroups } = useSelector((state) => ({
    caseformattributegroups: state.caseformattributesgroups.caseformattributegroups,
  }));
  const { caseformattributetemplates } = useSelector((state) => ({
    caseformattributetemplates: state.caseformattributetemplates.caseformattributetemplates,
  }));
  const { caseformattributetemplatesDetail } = useSelector((state) => ({
    caseformattributetemplatesDetail: state.caseformattributetemplates.caseformattributetemplatesDetail,
  }));

  const [formData, setFormData] = useState({
    "name": "",
    "attributesGroupIds": "",
    "status": "",
    "form_id": "",
    "tab": ""
  });


  // useEffect(() => {
  //   setFormData(caseformattributegroups);
  // }, [dispatch]);

  useEffect(() => {
    dispatch(getCaseFormsList());
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(getCaseFormAttributeGroups());
  // }, [dispatch]);
  useEffect(() => {
    if (formData?.form_id) {
      dispatch(getCaseFormAttributeGroups({ form_id: formData?.form_id }));
    }
  }, [formData]);


  useEffect(() => {
    setLists(
      (prevState) => ({
        ...prevState,
        items: caseformattributegroups
      }))
  }, [caseformattributegroups]);


  useEffect(() => {
    if (editId) {
      dispatch(getCaseFormAttributeTemplateDetail(editId));
    }
  }, [editId]);
  useEffect(() => {
    if (caseformattributetemplatesDetail && Object.entries(caseformattributetemplatesDetail).length > 0) {
      let { attributesGroupIds } = caseformattributetemplatesDetail;
      let attributesArr = attributesGroupIds.split(',');
      let filteredList = caseformattributegroups.filter((item) => {
        if (attributesArr.includes(item.id.toString())) {
          return item
        }
      })
      setFormData(caseformattributetemplatesDetail);
      setLists({
        items: caseformattributegroups,
        // selected: filteredList
        selected: caseformattributetemplatesDetail.selectedAttributeGroupsList
      });
    }
  }, [caseformattributetemplatesDetail])


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let attributesGroupIds = lists.selected.map((item) => {
      return item.id;
    })

    attributesGroupIds = attributesGroupIds.join(",");
    let postBody = { ...formData, attributesGroupIds };
    if (postBody.name) {
      let response = {};
      if (Number(formData.id) > 0) {
        dispatch(updateCaseformAttributetemplates(postBody));

      } else {
        dispatch(addcaseformAttributetemplate(postBody));

      }
      setFormData({
        "form_id": "",
        "id": "",
        "name": "",
        "shortDescription": "",
        "description": "",
        "attributesGroupIds": "",
        "status": ""
      });
      navigate("/admin/case-form-attribute-templates");


    }
  }
  const onClickCancel = () => {
    navigate("/admin/case-form-attribute-templates");
  }
  const [lists, setLists] = useState({ 'items': caseformattributegroups, 'selected': [] });
  const id2List = {
    droppable: 'items',
    droppable2: 'selected'
  };

  const getList = id => lists[id2List[id]];
  //console.log(lists['items'], '--- list ids===========');
  const onDragEnd = result => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      const items = reorder(
        getList(source.droppableId),
        source.index,
        destination.index
      );

      let state = { items };

      if (source.droppableId === 'droppable2') {
        state = { selected: items };
      }
      let newstate = {
        ...lists,
        ...state
      }
      setLists(newstate);

    } else {
      const result = move(
        getList(source.droppableId),
        getList(destination.droppableId),
        source,
        destination
      );

      setLists({
        items: result.droppable,
        selected: result.droppable2
      });
    }
  };

  const [selectedOptions, setSelectedOptions] = useState([]);
  const selectedOptionsUpdate = (options) => {
    var form_ids = options.map((opt) => opt.value).toString();
    setFormData({ ...formData, ["form_id"]: form_ids });
    setSelectedOptions(options.map((opt) => opt.value));
  }
  
  const InputOption = ({
    getStyles,
    Icon,
    isDisabled,
    isFocused,
    isSelected,
    children,
    innerProps,
    ...rest
  }) => {
    const [isActive, setIsActive] = useState(false);
    const onMouseDown = () => setIsActive(true);
    const onMouseUp = () => setIsActive(false);
    const onMouseLeave = () => setIsActive(false);

    // styles
    let bg = "transparent";
    if (isFocused) bg = "#eee";
    if (isActive) bg = "#B2D4FF";

    const style = {
      alignItems: "center",
      backgroundColor: bg,
      color: "inherit",
      display: "flex "
    };

    // prop assignment
    const props = {
      ...innerProps,
      onMouseDown,
      onMouseUp,
      onMouseLeave,
      style
    };

    return (
      <components.Option
        {...rest}
        isDisabled={isDisabled}
        isFocused={isFocused}
        isSelected={isSelected}
        getStyles={getStyles}
        innerProps={props}
      >
        <input type="checkbox" checked={isSelected} /> &nbsp;
        {children}
      </components.Option>
    );
  };

  const BreadcrumbData = [
    { name: 'Case Form Attribute Templates', url: '/admin/case-form-attribute-templates' },
    { name: 'Add Case Form Attribute Template', url: '/admin/add-case-form-attribute-templates' }
  ]
  let title = editId ? 'Update Case Form Attribute Template' : 'Add Case Form Attribute Template';
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs breadcrumbItem={title} BreadcrumbData={BreadcrumbData} />

          <Row>
            <Col xs={12}>
              <form onSubmit={handleSubmit}>

                <div className="container">
                  <div className="row">
                    <DragDropContext onDragEnd={onDragEnd}>

                      <div className="col-lg-6 col-md-12">

                        <div className="card dashboard-secondbox dashboard-border-radius">

                          <h5>Case Form Attributes Group</h5>
                          <p>Please drag and drop and Make sets.</p>

                          <div className=''>
                            <div className="">
                              <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                  <ul className="list-group border"

                                    ref={provided.innerRef}
                                    style={getFirstListStyle(snapshot.isDraggingOver)}
                                  >
                                    {lists['items'].map((item, index) => (
                                      <Draggable
                                        key={item.id.toString()}
                                        draggableId={item.id.toString()}
                                        index={index}>
                                        {(provided, snapshot) => (
                                          <li className="list-group-item border"
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          >
                                            {item.title}
                                          </li>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}

                                  </ul>
                                )}
                              </Droppable>
                            </div>

                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-12">


                        <div className="card dashboard-secondbox dashboard-border-radius">
                          <h5>Creat Case Form Attribute Template</h5>


                          <div className="">
                            <div className="mb-3">
                              <label htmlFor="formGroupExampleInput" className="form-label">
                                Label:
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="formGroupExampleInput"
                                placeholder="Enter Label"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                              />
                            </div>
                            <div className="mb-3">
                              <Label
                                htmlFor="horizontal-firstname-input"
                                className="col-sm-2 col-form-label"
                              >
                                Case Form:
                              </Label>
                              <div className="col-lg-6 col-md-12">
                                {/* <Input
                                  id="form_id"
                                  name="form_id"
                                  type="select"
                                  onChange={handleChange}
                                  disabled={caseformattributetemplatesDetail?.form_id ? true : false}
                                >
                                  <option value="">Select Case Form</option>
                                  {CaseFormsList.map(row => (
                                    <option key={row.form_id} value={row.form_id} selected={row.form_id == caseformattributetemplatesDetail?.form_id}>
                                      {row.form_name || row.name}
                                    </option>
                                  ))}
                                </Input> */}


                                <Select
                                  defaultValue={[]}
                                  value={CaseFormsSelectList.filter((value, index) => {
                                    if (formData?.form_id) {
                                      let selected = formData.form_id.split(",")
                                      return selected.includes(value.value)
                                    }
                                  })}
                                  isMulti
                                  // className={selectedOptions.length === 0 ? 'is-invalid':''}
                                  name="form_id"
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={true}
                                  selected={CaseFormsSelectList.filter(({ value }) =>
                                    caseformattributetemplatesDetail?.form_id ?
                                      (caseformattributetemplatesDetail.form_id.split(",")).includes(value) : ''
                                  )}
                                  // onChange={handleChange}
                                  onChange={(options) => {
                                    //console.log(options)
                                    if (Array.isArray(options)) {
                                      selectedOptionsUpdate(options)
                                    }
                                  }}

                                  // value={caseformattributetemplatesDetail?.form_id ? caseformattributetemplatesDetail.form_id : ''}
                                  options={CaseFormsSelectList}
                                  components={{
                                    Option: InputOption
                                  }}
                                />

                              </div><br></br>
                            </div>
                            <div className="mb-3">
                              <label htmlFor="formGroupExampleInput" className="form-label">
                                Case Form Attributes Group:
                              </label>
                              <p>Please drag and drop from left to right.</p>

                            </div>
                            <Droppable droppableId="droppable2">
                              {(provided, snapshot) => (
                                <ul className="list-group"
                                  ref={provided.innerRef}
                                  style={getListStyle(snapshot.isDraggingOver)}>
                                  {lists['selected'].map((item, index) => (
                                    <Draggable
                                      key={item.id.toString()}
                                      draggableId={item.id.toString()}
                                      index={index}>
                                      {(provided, snapshot) => (
                                        <li className="list-group-item"
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}>
                                          {item.title}
                                        </li>
                                      )}
                                    </Draggable>
                                  ))}
                                  {provided.placeholder}
                                </ul>
                              )}
                            </Droppable>
                            <div className="mb-3">
                              <Label
                                htmlFor="horizontal-firstname-input"
                                className="col-sm-2 col-form-label"
                              >
                                Tab:
                              </Label>
                              <div className="col-lg-6 col-md-12">
                                <Input
                                  id="tab"
                                  name="tab"
                                  type="select"
                                  onChange={handleChange}
                                >
                                  <option value="">Select Case Form</option>
                                  <option value="main" selected={"main" === caseformattributetemplatesDetail.tab}> Main</option>
                                  <option value="application" selected={"application" === caseformattributetemplatesDetail.tab}>Application</option>
                                </Input>

                              </div>
                            </div>


                            <div className="mb-3">
                              <label htmlFor="formGroupExampleInput2" className="form-label">
                                Status:
                              </label>


                              <Input
                                id="validationCustom02"
                                name="status"
                                type="select"
                                onChange={handleChange}
                                value={formData.status || ""}

                              >
                                <option >Open this select status</option>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                              </Input>




                            </div>
                            <button type="button" className="btn btn-secondary" onClick={onClickCancel}>
                              Cancel
                            </button> {' '}
                            <button type="submit" className="btn btn-primary">
                              save
                            </button>

                          </div>

                        </div>

                      </div>

                    </DragDropContext>
                  </div>
                </div>

              </form>
            </Col>
          </Row>


        </Container>
      </div>
    </React.Fragment>
  );
};
export default FormLayoutsBasic
